export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6566.ad062dfb.jpg";